import React from 'react';
import { Link } from 'react-router-dom'; // For logo link to home
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
       <img className="footer-logo" src="/images/white-logo.svg"/>
       <p className="phone-number">Tél: (+216) 74 418 034 - 52 937 922</p>
       <a href="https://web.facebook.com/mahmoud.empac" target='_blank'><img className="fb-logo" src="/images/facebook-logo.svg"/>Facebook</a>
      </div>
    </footer>
  );
};

export default Footer;